// extracted by mini-css-extract-plugin
export var adjacentSlide = "_mf-9";
export var arrowButtonContainer = "_mf-5";
export var arrowButtonIcon = "_mf-6";
export var carouselArrowButton = "_mf-2";
export var carouselElementContainer = "_mf-1";
export var currentSlide = "_mf-8";
export var left = "_mf-3";
export var otherSlide = "_mf-a";
export var productCarouselContainer = "_mf-0";
export var right = "_mf-4";
export var sliderOverflow = "_mf-7";